import React, { useState } from 'react'
import { Row, Form } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'

export default function ManageProhibitedForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  return (
    <>
      <Form fluid>
        <Row>
          <InputForm
            schema={schema.prohibited}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Row>
      </Form>
    </>
  )
}
